var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from "lit";
import { query } from "lit/decorators.js";
import { customElement, PICBase, PIC, PICAction } from "../Internals";
const DEFAULT_TEXT = `
{xml/incl/xmlprog3.i}

function eventCheck {&VOID} (iEventCode as char, iSubWin as char, iRetVal as char): 
  case iEventCode:
    when 'open' or when 'load' or when 'refresh' then .
    when 'back' then return2Parent('').  
    when 'exit' then return2Module('util/logon').
    otherwise do:
      {xml/incl/xmlprog3dyne.i}
    end.
  end case.
  {&VOID_RET}
end function.
`;
//TODO Preview xmlprog3 (and2) from editor code
//TODO Multiple types of previews
//TODO Monaco editor (type of textarea ?)
let PICPreviewEditor = class PICPreviewEditor extends PICBase {
    constructor() {
        super();
        this.submitAction = new PICAction();
        this.resetEditorAction = new PICAction();
        this.resetFrameAction = new PICAction();
        this.blankAction = new PICAction();
    }
    connectedCallback() {
        super.connectedCallback();
        let sessionData = sessionStorage.getItem('editor_code');
        if (sessionData) {
            this.data = sessionData;
        }
        else {
            this.resetEditor();
        }
        window._log('Connected Callback', this);
    }
    firstUpdated() {
        this.submitAction.type_ = 'internal';
        this.submitAction.eventFnc = this.submitData.bind(this);
        this.resetEditorAction.type_ = 'internal';
        this.resetEditorAction.eventFnc = this.resetEditor.bind(this);
        this.resetFrameAction.type_ = 'internal';
        this.resetFrameAction.eventFnc = this.resetFrame.bind(this);
        this.blankAction.type_ = 'internal';
        this.blankAction.eventFnc = (() => { }).bind(this);
    }
    static get styles() {
        const defaultStyle = css `
            .outerContainer {
                display: grid;
                grid-template-rows: 4rem 1fr;
                grid-template-columns: 1fr 1fr;
                grid-template-areas:
                'topLeft topRight'
                'editorContainer resultContainer'
                ;
                height: 100vh;
                margin-left: 8px;
            }
            .topLeft {
                grid-area: topLeft;
                display: inline-flex;
                border-bottom: 1px solid black;
            }
            .topRight {
                grid-area: topRight;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
            }
            .editorContainer {
                grid-area: editorContainer;
                width: 100%;
                height: 100%;
            }
            .resultContainer {
                grid-area: resultContainer;
                border-left: 1px solid black;
                width: 100%;
                height: 100%;
            }
		`;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    resetEditor() {
        window._log('Resetting data', this);
        this.data = DEFAULT_TEXT;
        sessionStorage.removeItem('editor_code');
        if (this.editor)
            this.editor.editorData = this.data;
    }
    saveInput() {
        sessionStorage.setItem('editor_code', this.editor.editorData);
    }
    resetFrame() {
        var _a, _b;
        window._log('Resetting frame', this, this.frame);
        (_b = (_a = this.frame) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.document.location.reload();
    }
    writeToFrame(data) {
        var _a, _b;
        (_a = this.frame.contentWindow) === null || _a === void 0 ? void 0 : _a.document.write(data);
        (_b = this.frame.contentWindow) === null || _b === void 0 ? void 0 : _b.document.close();
    }
    checkAndConsumeInlineData() {
        let iData = this.getAttribute('datafromprogress');
        if (iData) {
            try {
                this.data = atob(iData);
            }
            catch (_a) {
                PIC.getInstance.msg('parsing inline data has failed');
            }
        }
        this.removeAttribute('datafromprogress');
    }
    submitData() {
        window._log('Submitting data', this);
        let data = this.editor.editorData;
        let data_b64 = btoa(data).replace(/=/g, 'hans'); //to fit type application/x-www-form-urlencoded
        //Currently using the web2pro method
        let sessionCode = PIC.getInstance.sessionCode; //'picit_nk.2459790.59921669.1'
        let system = PIC.getInstance.systemId;
        let eventid = this.runEvent.value.length > 0 ? this.runEvent.value : 'load';
        fetch('/web', {
            method: 'POST',
            headers: [
                ['content-type', 'application/x-www-form-urlencoded']
            ],
            body: 'moduleId=ScrollTab1' +
                '&eventid=template' +
                '&SessionCode=' + sessionCode +
                '&SystemId=' + system +
                '&CurLang=' +
                '&Subwin=test/tool/web/playground' +
                '&datemode=YMD' +
                '&templateEvent=' + eventid +
                '&templateData=' + data_b64
        }).then(response => response.text())
            .then(html => {
            window._log('Template Response', html);
            this.writeToFrame(html);
        });
    }
    doURI(front, back) {
        let arr = location.hostname.split('.');
        arr[0] = front;
        return `${location.protocol}//${arr.join('.')}${back ? '/' + back : ''}`;
    }
    render() {
        window._log('Rendering preview editor');
        this.checkAndConsumeInlineData();
        return html `
            ${this.renderCSS(true)}
			<div class="outerContainer">
                <div class="topLeft">
                    <h1>Code</h1>
                    <pic-button id="run" .action=${this.submitAction} label="RUN" etype="contained" density="medium"></pic-button>
                    <pic-input id="event" label="Input Event" placeholder="load" etype="contained" density="medium"></pic-input>
                    <pic-button id="rset-edi" .action=${this.resetEditorAction} label="RESET EDITOR" etype="contained" density="medium"></pic-button>
                    <pic-button id="rset-frm" .action=${this.resetFrameAction} label="RESET FRAME" etype="contained" density="medium"></pic-button>
                </div>
                <div class="topRight">
                    <h1>Result</h1>
                </div>
                <div class="editorContainer">
                    <pic-editor id="editor" .editorLanguage=${'abl'} .editorWidth=${"99%"} .editorData=${this.data}></pic-editor>
                </div>
                <div class="resultContainer">
                    <iframe width="100%" height="100%" id="frame" src="${this.doURI('udv', 'web')}"></iframe>
                </div>
            </div>
		`;
    }
};
__decorate([
    query('#run')
], PICPreviewEditor.prototype, "runBtn", void 0);
__decorate([
    query('#event')
], PICPreviewEditor.prototype, "runEvent", void 0);
__decorate([
    query('#rset_edi')
], PICPreviewEditor.prototype, "rEdiBtn", void 0);
__decorate([
    query('#rset_frm')
], PICPreviewEditor.prototype, "rFrmBtn", void 0);
__decorate([
    query('#editor')
], PICPreviewEditor.prototype, "editor", void 0);
__decorate([
    query('#frame')
], PICPreviewEditor.prototype, "frame", void 0);
PICPreviewEditor = __decorate([
    customElement('pic-previeweditor')
], PICPreviewEditor);
//# sourceMappingURL=PICPreviewEditor.js.map